var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "top",
            width: "300",
            title: "輸出目前條件資料到EXCEL",
          },
          on: { show: _vm.exportExcel, hide: _vm.clearData },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("el-input", {
            staticClass: "mb-2",
            attrs: {
              placeholder: _vm.placeholder,
              "prefix-icon": "el-icon-document",
            },
            model: {
              value: _vm.customFileName,
              callback: function ($$v) {
                _vm.customFileName = $$v
              },
              expression: "customFileName",
            },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.is_loading,
                  expression: "is_loading",
                },
              ],
              staticStyle: { "text-align": "right", margin: "0" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "text" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "vue-excel-xlsx",
                {
                  attrs: {
                    data: _vm.exportData,
                    columns: _vm.columns,
                    "file-name": _vm.customFileName
                      ? _vm.customFileName
                      : _vm.filename,
                    "sheet-name": "工作表1",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.exportExcel },
                    },
                    [_vm._v(" 儲存EXCEL ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "reference", type: "primary" },
              slot: "reference",
            },
            [_vm._v("輸出EXCEL")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }